import { render } from "./comasidepackuer.vue?vue&type=template&id=234119da&scoped=true"
const script = {}

import "./comasidepackuer.vue?vue&type=style&index=0&id=234119da&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234119da"]])

export default __exports__